import React from "react";
import Hero from "../components/Hero";
import ServiceSection from "../components/ServiceSection";
import WhyChoose from "../components/WhyChoose";
import ProjectSection from "../components/ProjectSection";
import Testimonials from "../components/Testimonials";

const Home = () => {
  return (
    <div>
      <Hero />
      <ServiceSection />

      <ProjectSection />
      <WhyChoose />
      <Testimonials />
    </div>
  );
};

export default Home;
